import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Schrift-Skala aus `globals.css` (@theme --text-*). tailwind-merge kennt
 * diese Namen sonst nicht, hält `text-body-sm` für eine Textfarbe und
 * verwirft es neben `text-slate-600` still (Befund 25.10.2026, u. a. alle
 * ModalHeader-Titel). Der Test `utils.test.ts` hält die Liste mit der CSS gleich.
 */
export const SCHRIFT_GROESSEN = [
  "micro",
  "overline",
  "caption",
  "body-sm",
  "body",
  "body-lg",
  "title",
  "heading",
  "display-md",
  "display-lg",
  "display-xl",
] as const;

const twMerge = extendTailwindMerge({
  extend: { theme: { text: [...SCHRIFT_GROESSEN] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
